// Alsahra Jewelry - Infinite Scroll for Collection Pages
// Automatically loads next page of products when user scrolls near the bottom

(function () {
  'use strict';

  function initInfiniteScroll() {
    var productList = document.getElementById('aj-product-list');
    var sentinel = document.getElementById('aj-infinite-scroll-sentinel');
    var spinner = document.getElementById('aj-load-more-spinner');
    var allLoadedMsg = document.getElementById('aj-all-loaded-msg');

    if (!productList || !sentinel) return;

    var isLoading = false;
    var nextUrl = productList.getAttribute('data-next-url');
    var totalPages = parseInt(productList.getAttribute('data-total-pages'), 10);
    var currentPage = parseInt(productList.getAttribute('data-current-page'), 10);

    if (!nextUrl || currentPage >= totalPages) {
      if (allLoadedMsg && totalPages > 0) allLoadedMsg.style.display = 'block';
      return;
    }

    function loadNextPage() {
      if (isLoading || !nextUrl) return;
      isLoading = true;
      if (spinner) spinner.style.display = 'block';

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newList = doc.getElementById('aj-product-list');

          if (newList) {
            var newItems = Array.from(newList.children);
            newItems.forEach(function (item) {
              productList.appendChild(item);
            });

            // Update next URL
            var updatedNextUrl = newList.getAttribute('data-next-url');
            var updatedCurrentPage = parseInt(newList.getAttribute('data-current-page'), 10);
            var updatedTotalPages = parseInt(newList.getAttribute('data-total-pages'), 10);

            nextUrl = updatedNextUrl || null;
            currentPage = updatedCurrentPage;
            totalPages = updatedTotalPages;

            // Update the current product list attributes
            productList.setAttribute('data-next-url', nextUrl || '');
            productList.setAttribute('data-current-page', currentPage);

            // Update browser URL without reload
            if (nextUrl) {
              var pageParam = new URL(nextUrl, window.location.origin).searchParams.get('page');
              if (pageParam) {
                var newStateUrl = new URL(window.location.href);
                newStateUrl.searchParams.set('page', pageParam);
                history.replaceState(null, '', newStateUrl.toString());
              }
            }
          }

          if (spinner) spinner.style.display = 'none';
          isLoading = false;

          if (!nextUrl || currentPage >= totalPages) {
            if (allLoadedMsg) allLoadedMsg.style.display = 'block';
            if (observer) observer.disconnect();
          }
        })
        .catch(function (err) {
          console.error('Infinite scroll error:', err);
          if (spinner) spinner.style.display = 'none';
          isLoading = false;
        });
    }

    // Use IntersectionObserver to trigger load when sentinel is visible
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    }, { rootMargin: '400px' });

    observer.observe(sentinel);
  }

  // Add spinner CSS animation
  var style = document.createElement('style');
  style.textContent = '@keyframes aj-spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  } else {
    initInfiniteScroll();
  }

  // Re-init after Shopify section renders (for theme editor)
  document.addEventListener('shopify:section:load', initInfiniteScroll);
})();
